import React from 'react'
import { Gallery } from 'iconsax-react'
import { useTheme } from '@mui/material'

import ClickableAlt from '../ClickableAlt'
import LoadingIndicator from '../LoadingIndicator'

import { UseMediaHandleType } from '../../../../../hooks/useMediaHandle'
import useStyles from './styles'

type ImageProps = {
  mediaHandle: UseMediaHandleType
  onClick: () => void
}

const Image: React.FC<ImageProps> = ({ mediaHandle, onClick }) => {
  const theme = useTheme()

  const { media, srcURL, startLoad } = mediaHandle

  const classes = useStyles()

  // Load images automatically
  React.useEffect(() => {
    startLoad()
  }, [startLoad])

  return (
    <>
      <Gallery
        size={theme.size.xxxl}
        variant='Bold'
        color={theme.palette.primary.main}
        className={classes.icon}
      />

      <ClickableAlt onClick={onClick}>{media.filename}</ClickableAlt>

      {srcURL ? (
        <img src={srcURL} alt='' onClick={onClick} className={classes.image} />
      ) : (
        <LoadingIndicator loading onClick={() => {}} />
      )}
    </>
  )
}

export default Image
